import { render, staticRenderFns } from "./UnitVisitViewPanel.vue?vue&type=template&id=f2d809dc&scoped=true&"
import script from "./UnitVisitViewPanel.vue?vue&type=script&lang=js&"
export * from "./UnitVisitViewPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d809dc",
  null
  
)

export default component.exports